import PromoCodes from './PromoCodes';

export default PromoCodes;
